<template>
  <div>
    <div class="alert alert-danger" v-if="Object.keys(allBackendErrors).length > 0">
      <strong>
        <p>Some errors appeared.</p>
        <p>Please check the next sections: </p>
      </strong>
      <p v-for="(value, key, index) in allBackendErrors" :key="index">
        - {{ getStepName(key) }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConsultBackendErrors',
  props: [
    'storeNamespace',
  ],
  computed: {
    getStepName: function() {
      return this.$store.getters[this.storeNamespace+'/getStepName']
    },
    allBackendErrors: function() {
      return this.$store.getters[this.storeNamespace+'/allBackendErrors']
    },
  },
}
</script>
